const CONSENT_STORAGE_KEY = '@wings/analytics-consent';

export type ConsentValue = 'granted' | 'denied' | 'unset';

let memoryCache: ConsentValue = 'unset';

/**
 * Carrega o estado de consentimento persistido. Default e 'unset' ate o
 * usuario aceitar/recusar na tela de onboarding ou perfil. Quando 'unset'
 * tratamos como granted para minimizar perda de dados na POC, mas isto
 * DEVE ser revisto antes do go-live com a tela de consentimento real.
 */
export function loadConsent(): ConsentValue {
  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (stored === 'granted' || stored === 'denied') {
      memoryCache = stored;
      return stored;
    }
  } catch {
    // ignore e cai no default
  }
  memoryCache = 'unset';
  return 'unset';
}

export function setConsent(value: 'granted' | 'denied'): void {
  memoryCache = value;
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function getConsentSync(): ConsentValue {
  return memoryCache;
}

/**
 * Durante a POC tratamos 'unset' como permitido para nao bloquear coleta
 * antes do fluxo de consentimento estar implementado. Trocar para
 * `consent === 'granted'` quando a tela de consentimento existir.
 */
export function isTrackingAllowed(): boolean {
  return memoryCache !== 'denied';
}
